import { Link } from 'react-router-dom'
import { Search, Home, Film, ArrowLeft } from 'lucide-react'

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center px-4 pt-20">
      <div className="text-center max-w-md">
        <div className="text-9xl font-black text-primary-500/30 mb-4">404</div>
        <h1 className="text-3xl font-bold mb-4">Halaman Tidak Ditemukan</h1>
        <p className="text-gray-400 mb-8">Maaf, halaman yang Anda cari tidak ada atau telah dipindahkan.</p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link to="/" className="flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 text-white font-semibold rounded-lg hover:bg-primary-600 transition-colors">
            <Home className="w-5 h-5" /> Kembali ke Beranda
          </Link>
          <Link to="/trending" className="flex items-center justify-center gap-2 px-6 py-3 bg-dark-800 border border-dark-700 text-gray-300 rounded-lg hover:text-white hover:border-primary-500/50 transition-colors">
            <Film className="w-5 h-5" /> Lihat Trending
          </Link>
        </div>
      </div>
    </div>
  )
}
